import type { ChoirEvent, TransportEntry } from '../types'
import { idOf } from './members'

/** Fixed "today" for the prototype. */
export const TODAY = '2026-09-02'
export const SEZONA = '2026/27'

const osnovniDogodki: ChoirEvent[] = [
  // ——— pretekli dogodki ———
  {
    id: 'e01',
    type: 'vaja',
    datum: '2026-09-11',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    opis: 'Uvodna vaja nove sezone.',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e02',
    type: 'zbor',
    naslov: 'Redni zbor članov (september)',
    datum: '2026-09-18',
    zacetek: '18:30',
    konec: '20:00',
    lokacija: 'Prosvetni dom Brežice, sejna soba',
    opis: 'Poročila o sezoni, potrditev programa in volitve v komisije.',
    steje: false,
    obcinstvo: 'vsi',
    dokumenti: [
      {
        id: 'd01',
        ime: 'Vabilo na redni zbor članov.pdf',
        kind: 'vabilo',
        dodano: '2026-09-04',
        link: 'https://drive.google.com/file/d/viva-vabilo-september',
      },
      {
        id: 'd02',
        ime: 'Dnevni red — 18. 9. 2026.pdf',
        kind: 'dnevni_red',
        dodano: '2026-09-04',
        link: 'https://drive.google.com/file/d/viva-dnevni-red-september',
      },
      {
        id: 'd03',
        ime: 'Finančno poročilo 2025.xlsx',
        kind: 'gradivo',
        dodano: '2026-09-10',
        link: 'https://drive.google.com/file/d/viva-financno-porocilo',
      },
      {
        id: 'd04',
        ime: 'Zapisnik rednega zbora članov — 18. 9. 2026.pdf',
        kind: 'zapisnik',
        dodano: '2026-09-24',
        link: 'https://drive.google.com/file/d/viva-zapisnik-september',
      },
    ],
  },
  {
    id: 'e03',
    type: 'vaja',
    datum: '2026-09-25',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e04',
    type: 'sekcijska',
    datum: '2026-10-06',
    zacetek: '18:30',
    konec: '20:00',
    lokacija: 'Glasbena šola Brežice, učilnica 12',
    glasovi: ['sopran'],
    steje: true,
    obcinstvo: 'glasovi',
  },
  {
    id: 'e05',
    type: 'vaja',
    datum: '2026-10-09',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e06',
    type: 'intenzivna',
    datum: '2026-10-17',
    zacetek: '09:00',
    konec: '15:00',
    lokacija: 'Dom kulture Bizeljsko',
    opomba: 'Mozart Requiem',
    opis: 'Celodnevna intenzivna vaja z odmorom za kosilo.',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e07',
    type: 'vaja',
    datum: '2026-10-23',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e08',
    type: 'nastop',
    naslov: 'Nastop ob občinskem prazniku',
    datum: '2026-10-31',
    zacetek: '18:00',
    konec: '19:30',
    lokacija: 'Viteška dvorana, Posavski muzej Brežice',
    opomba: 'v koncertnih oblekah',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e09',
    type: 'vaja',
    datum: '2026-11-06',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e10',
    type: 'vaja',
    datum: '2026-11-13',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    opomba: 'Mozart Requiem',
    steje: true,
    obcinstvo: 'aktivni',
  },

  // ——— prihajajoči dogodki ———
  {
    id: 'e11',
    type: 'vaja',
    datum: '2026-11-20',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    opis: 'Priprava programa za božični koncert.',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e12',
    type: 'sekcijska',
    datum: '2026-11-24',
    zacetek: '18:30',
    konec: '20:00',
    lokacija: 'Glasbena šola Brežice, učilnica 12',
    glasovi: ['tenor', 'bariton'],
    opis: 'Utrjevanje tenorskih linij v Requiemu.',
    steje: true,
    obcinstvo: 'glasovi',
  },
  {
    id: 'e13',
    type: 'intenzivna',
    datum: '2026-11-27',
    zacetek: '18:00',
    konec: '21:30',
    lokacija: 'Prosvetni dom Brežice, velika dvorana',
    opomba: 'Mozart Requiem',
    opis: 'Daljša vaja pred decembrskim ciklom.',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e14',
    type: 'vaja',
    datum: '2026-12-04',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e15',
    type: 'sekcijska',
    datum: '2026-12-08',
    zacetek: '18:30',
    konec: '20:00',
    lokacija: 'Glasbena šola Brežice, učilnica 12',
    glasovi: ['sopran', 'alt'],
    steje: true,
    obcinstvo: 'glasovi',
  },
  {
    id: 'e16',
    type: 'vaja',
    datum: '2026-12-11',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e17',
    type: 'generalka',
    naslov: 'Generalka — v koncertnih oblekah',
    datum: '2026-12-18',
    zacetek: '17:00',
    konec: '19:30',
    lokacija: 'Cerkev sv. Lovrenca, Brežice',
    opomba: 'pol ure prej',
    opis: 'Zbor ob 16.30 pri stranskem vhodu. Prinesite mape in koncertne obleke.',
    steje: true,
    obcinstvo: 'vsi',
  },
  {
    id: 'e18',
    type: 'nastop',
    naslov: 'Božični koncert',
    datum: '2026-12-19',
    zacetek: '19:00',
    konec: '20:30',
    lokacija: 'Cerkev sv. Lovrenca, Brežice',
    opomba: 'v koncertnih oblekah',
    opis: 'Osrednji koncert sezone. Zbor ob 18.00.',
    steje: true,
    obcinstvo: 'vsi',
  },
  {
    id: 'e19',
    type: 'vaja',
    datum: '2027-01-08',
    zacetek: '19:00',
    konec: '21:00',
    lokacija: 'Prosvetni dom Brežice, mala dvorana',
    opis: 'Prva vaja v letu 2027.',
    steje: true,
    obcinstvo: 'aktivni',
  },
  {
    id: 'e20',
    type: 'nastop',
    naslov: 'Novoletni koncert — Krško',
    datum: '2027-01-23',
    zacetek: '19:30',
    konec: '21:00',
    lokacija: 'Kulturni dom Krško',
    opomba: 'v koncertnih oblekah',
    steje: true,
    obcinstvo: 'vsi',
  },
]

/** ——— organizacijski dogodki in gostovanje ——— */
export const dodatniDogodki: ChoirEvent[] = [
  {
    id: 'e21',
    type: 'sestanek',
    naslov: 'Seja upravnega odbora',
    datum: '2026-11-23',
    zacetek: '18:00',
    konec: '19:15',
    lokacija: 'Prosvetni dom Brežice, sejna soba',
    opis: 'Pregled programa za pomladni koncert in predlogi za gostovanje.',
    steje: false,
    obcinstvo: 'funkcije',
    funkcije: [
      'uo_predsednik',
      'uo_tajnik',
      'uo_blagajnik',
      'uo_strokovni',
      'uo_clan',
      'uo_opazovalec',
    ],
    dokumenti: [
      {
        id: 'd11',
        ime: 'Dnevni red — seja UO.pdf',
        kind: 'dnevni_red',
        dodano: '2026-11-18',
        link: 'https://drive.google.com/file/d/viva-uk-dnevni-red',
      },
      {
        id: 'd12',
        ime: 'Predlog programa 2027.pdf',
        kind: 'gradivo',
        dodano: '2026-11-18',
        link: 'https://drive.google.com/file/d/viva-program-2027',
      },
    ],
  },
  {
    id: 'e22',
    type: 'zbor',
    naslov: 'Redni zbor članov',
    datum: '2026-12-02',
    zacetek: '18:30',
    konec: '20:00',
    lokacija: 'Prosvetni dom Brežice, sejna soba',
    opis: 'Potrditev finančnega načrta 2027 in program gostovanja na Dunaju.',
    opomba: 'obvezna udeležba',
    steje: false,
    obcinstvo: 'vsi',
    dokumenti: [
      {
        id: 'd21',
        ime: 'Vabilo na redni zbor članov — 2. 12. 2026.pdf',
        kind: 'vabilo',
        dodano: '2026-11-16',
        link: 'https://drive.google.com/file/d/viva-vabilo-december',
      },
      {
        id: 'd22',
        ime: 'Dnevni red — 2. 12. 2026.pdf',
        kind: 'dnevni_red',
        dodano: '2026-11-16',
        link: 'https://drive.google.com/file/d/viva-dnevni-red-december',
      },
      {
        id: 'd23',
        ime: 'Finančni načrt 2027.xlsx',
        kind: 'gradivo',
        dodano: '2026-11-17',
        link: 'https://drive.google.com/file/d/viva-financni-nacrt-2027',
      },
    ],
  },
  {
    id: 'e23',
    type: 'nastop',
    naslov: 'Mednarodni zborovski festival — Dunaj',
    datum: '2027-03-12',
    datumDo: '2027-03-15',
    zacetek: '06:00',
    konec: '20:00',
    lokacija: 'Dunaj, Avstrija',
    opis:
      'Štiridnevno gostovanje z nastopom v dvorani Musikverein (13. 3.) in skupnim koncertom z gostiteljskim zborom (14. 3.).',
    opomba: 'v koncertnih oblekah',
    steje: true,
    obcinstvo: 'izbrani',
    clani: [
      'm01',
      'm02',
      'm03',
      'm04',
      'm05',
      'm07',
      'm09',
      'm11',
      'm12',
      'm16',
      'm17',
      'm20',
      'm24',
      'm29',
      'm31',
      'm36',
      'm40',
      'm42',
    ],
    dokumenti: [
      {
        id: 'd31',
        ime: 'Program festivala — Dunaj 2027.pdf',
        kind: 'gradivo',
        dodano: '2026-11-12',
        link: 'https://drive.google.com/file/d/viva-dunaj-program',
      },
      {
        id: 'd32',
        ime: 'Seznam potrebne opreme in oblek.pdf',
        kind: 'priloga',
        dodano: '2026-11-12',
        link: 'https://drive.google.com/file/d/viva-dunaj-oprema',
      },
    ],
    potovanje: {
      aktivno: true,
      odhod: '12. 3. 2027 ob 6.00',
      prihod: '15. 3. 2027 okoli 20.00',
      zborno: 'Parkirišče pred Prosvetnim domom Brežice',
      opis:
        'Potujemo z osebnimi avtomobili v koloni. Prosimo, da se prevoz uskladi vnaprej, odhod je točen.',
      obveznaPolja: ['datumRojstva', 'dokumentTip', 'dokumentStevilka', 'prehrana'],
      nastanitev: {
        aktivno: true,
        ime: 'Hotel Zeitgeist Vienna, Sonnwendgasse 15',
        nacin: 'vodstvo',
        sobe: [
          { id: 'r1', ime: 'Soba 101', kapaciteta: 6 },
          { id: 'r2', ime: 'Soba 102', kapaciteta: 6 },
          { id: 'r3', ime: 'Soba 204', kapaciteta: 4 },
          { id: 'r4', ime: 'Soba 205', kapaciteta: 2 },
        ],
      },
      prevoz: { aktivno: true },
    },
  },
]

/** ——— Intenzivne vaje Pacug, 4.–6. 9. 2026 ——— */

/** Sobe v Pacugu: 2 × 6 oseb, 5 × 4 osebe, 3 × 2 osebi. */
const pacugSobe = [
  { id: 'ps1', ime: 'Soba 1', kapaciteta: 6 },
  { id: 'ps2', ime: 'Soba 2', kapaciteta: 6 },
  { id: 'ps3', ime: 'Soba 3', kapaciteta: 4 },
  { id: 'ps4', ime: 'Soba 4', kapaciteta: 4 },
  { id: 'ps5', ime: 'Soba 5', kapaciteta: 4 },
  { id: 'ps6', ime: 'Soba 6', kapaciteta: 4 },
  { id: 'ps11', ime: 'Soba 11', kapaciteta: 4 },
  { id: 'ps8', ime: 'Soba 8', kapaciteta: 2 },
  { id: 'ps9', ime: 'Soba 9', kapaciteta: 2 },
  { id: 'ps10', ime: 'Soba 10', kapaciteta: 2 },
]

/** Udeleženci intenzivnih vaj v Pacugu. */
const pacugUdelezenci: [string, string][] = [
  ['Krištof', 'Strnad'],
  ['Dejan', 'Jerončič'],
  ['Judita', 'Volčanšek'],
  ['Timotej', 'Siter'],
  ['Barbara', 'Ganzitti Siter'],
  ['Alenka', 'Črnelič Krošelj'],
  ['Jurij', 'Žnideršič'],
  ['Jelka', 'Žnideršič'],
  ['Simona', 'Rožman Strnad'],
  ['Uroš', 'Brezovšek'],
  ['Benjamin', 'Ferk'],
  ['Maj', 'Medvešek'],
  ['Ivanka', 'Črnelič Jurečič'],
  ['Maruša', 'Ferenčak'],
  ['Katja', 'Plevnik'],
  ['Lora Ana', 'Starič'],
  ['Katarina', 'Petrič'],
  ['Aljaž', 'Arh'],
  ['Irena', 'Hribar'],
  ['Mateja', 'Jankovič Čurič'],
  ['Florijan', 'Volčanšek'],
  ['Janž', 'Rener'],
  ['Ana', 'Špiler'],
  ['Bojan', 'Kaplan'],
  ['Lara', 'Krivec'],
  ['Sabina', 'Žibert'],
  ['Karmen', 'Kukovičič'],
  ['Jasna', 'Polovič'],
  ['Dean Jan', 'Petan'],
  ['Kaja', 'Strnad'],
  ['Amir', 'Tokić'],
  ['Robert', 'Rožman'],
  ['Neli', 'Škofca'],
  ['Jure', 'Pregelj'],
  ['Anja', 'Lipej'],
]

/** Razporeditev po sobah, kot jo je pripravilo vodstvo. */
const pacugRazpored: Record<string, [string, string][]> = {
  ps1: [
    ['Ivanka', 'Črnelič Jurečič'],
    ['Alenka', 'Črnelič Krošelj'],
    ['Mateja', 'Jankovič Čurič'],
    ['Anja', 'Lipej'],
    ['Simona', 'Rožman Strnad'],
  ],
  ps2: [
    ['Benjamin', 'Ferk'],
    ['Aljaž', 'Arh'],
    ['Maj', 'Medvešek'],
    ['Florijan', 'Volčanšek'],
  ],
  ps3: [
    ['Dejan', 'Jerončič'],
    ['Dean Jan', 'Petan'],
  ],
  ps4: [['Robert', 'Rožman']],
  ps5: [
    ['Lora Ana', 'Starič'],
    ['Katarina', 'Petrič'],
    ['Karmen', 'Kukovičič'],
    ['Jasna', 'Polovič'],
  ],
  ps6: [
    ['Katja', 'Plevnik'],
    ['Neli', 'Škofca'],
    ['Janž', 'Rener'],
    ['Judita', 'Volčanšek'],
  ],
  ps11: [
    ['Ana', 'Špiler'],
    ['Jure', 'Pregelj'],
    ['Lara', 'Krivec'],
  ],
  ps8: [
    ['Krištof', 'Strnad'],
    ['Kaja', 'Strnad'],
  ],
  ps9: [
    ['Jelka', 'Žnideršič'],
    ['Jurij', 'Žnideršič'],
  ],
  ps10: [
    ['Timotej', 'Siter'],
    ['Barbara', 'Ganzitti Siter'],
  ],
}

/** Prevozi (AVTO 1–6) — voznik s prostimi mesti in sopotniki. */
const pacugPrevozi: {
  voznik: [string, string]
  mesta: number
  kraj: string
  ura: string
  opomba?: string
  sopotniki: [string, string][]
}[] = [
  {
    voznik: ['Uroš', 'Brezovšek'],
    mesta: 4,
    kraj: 'Ljubljana',
    ura: '13:00',
    opomba: 'Pride v petek iz Ljubljane ob 13.00.',
    sopotniki: [],
  },
  {
    voznik: ['Jurij', 'Žnideršič'],
    mesta: 8,
    kraj: 'Brežice',
    ura: '15:00',
    sopotniki: [
      ['Jelka', 'Žnideršič'],
      ['Irena', 'Hribar'],
      ['Maj', 'Medvešek'],
      ['Benjamin', 'Ferk'],
      ['Aljaž', 'Arh'],
      ['Dejan', 'Jerončič'],
    ],
  },
  {
    voznik: ['Ivanka', 'Črnelič Jurečič'],
    mesta: 4,
    kraj: 'Brežice',
    ura: '15:00',
    sopotniki: [
      ['Ana', 'Špiler'],
      ['Amir', 'Tokić'],
      ['Lora Ana', 'Starič'],
      ['Sabina', 'Žibert'],
    ],
  },
  {
    voznik: ['Florijan', 'Volčanšek'],
    mesta: 4,
    kraj: 'Brežice',
    ura: '15:15',
    sopotniki: [
      ['Judita', 'Volčanšek'],
      ['Katja', 'Plevnik'],
      ['Janž', 'Rener'],
      ['Neli', 'Škofca'],
    ],
  },
  {
    voznik: ['Timotej', 'Siter'],
    mesta: 8,
    kraj: 'Krško',
    ura: '14:45',
    sopotniki: [
      ['Barbara', 'Ganzitti Siter'],
      ['Robert', 'Rožman'],
    ],
  },
  {
    voznik: ['Simona', 'Rožman Strnad'],
    mesta: 4,
    kraj: 'Brežice',
    ura: '15:30',
    sopotniki: [['Kaja', 'Strnad']],
  },
]

const pacug: ChoirEvent = {
  id: 'e24',
  type: 'intenzivna',
  naslov: 'Intenzivne vaje — Pacug',
  datum: '2026-09-04',
  datumDo: '2026-09-06',
  zacetek: '17:00',
  konec: '14:00',
  lokacija: 'Dom CŠOD Pacug, Portorož',
  opomba: 'Intenzivne',
  opis:
    'Vikend intenzivnih vaj pred jesenskim delom sezone. Prihod v petek popoldne, zaključek v nedeljo po kosilu. S seboj prinesite mape z notami, športna oblačila in kopalke.',
  steje: true,
  obcinstvo: 'izbrani',
  clani: pacugUdelezenci.map(([i, p]) => idOf(i, p)),
  dokumenti: [
    {
      id: 'd41',
      ime: 'Urnik intenzivnih vaj — Pacug.pdf',
      kind: 'gradivo',
      dodano: '2026-08-28',
      link: 'https://drive.google.com/file/d/viva-pacug-urnik',
    },
    {
      id: 'd42',
      ime: 'Seznam sob in prevozov — Pacug.xlsx',
      kind: 'priloga',
      dodano: '2026-08-30',
      link: 'https://drive.google.com/file/d/viva-pacug-sobe-prevozi',
    },
  ],
  potovanje: {
    aktivno: true,
    odhod: 'petek, 4. 9. 2026 ob 15.00 (Uroš že ob 13.00 iz Ljubljane)',
    prihod: 'nedelja, 6. 9. 2026 okoli 16.00',
    zborno: 'Parkirišče pred Prosvetnim domom Brežice',
    opis:
      'Posebnosti prihodov in odhodov: Maruša Ferenčak in Mateja Jankovič Čurič prideta v soboto zvečer in ostaneta do konca; Bojan Kaplan in Lara Krivec prideta v soboto dopoldne.',
    obveznaPolja: ['datumRojstva', 'prehrana'],
    nastanitev: {
      aktivno: true,
      ime: 'Dom CŠOD Pacug — 2 × soba za 6, 5 × soba za 4, 3 × soba za 2',
      nacin: 'vodstvo',
      sobe: pacugSobe,
    },
    prevoz: { aktivno: true },
  },
}

const pacugSobeMap: Record<string, string> = {}
Object.entries(pacugRazpored).forEach(([sobaId, osebe]) => {
  osebe.forEach(([i, p]) => {
    pacugSobeMap[idOf(i, p)] = sobaId
  })
})

const pacugPrevozMap: Record<string, TransportEntry> = {}
pacugPrevozi.forEach(({ voznik, mesta, kraj, ura, opomba, sopotniki }) => {
  const voznikId = idOf(voznik[0], voznik[1])
  pacugPrevozMap[voznikId] = { nacin: 'vozim', mesta, kraj, ura, opomba }
  sopotniki.forEach(([i, p]) => {
    pacugPrevozMap[idOf(i, p)] = { nacin: 'potrebujem', voznikId }
  })
})
pacugPrevozMap[idOf('Krištof', 'Strnad')] = { nacin: 'sam' }
pacugPrevozMap[idOf('Bojan', 'Kaplan')] = { nacin: 'sam' }
pacugPrevozMap[idOf('Lara', 'Krivec')] = { nacin: 'sam' }

/** Začetna razporeditev po sobah (dogodek → član → soba). */
export const zacetneSobe: Record<string, Record<string, string>> = {
  e24: pacugSobeMap,
  e23: {
    m03: 'r1',
    m11: 'r1',
    m12: 'r1',
    m16: 'r1',
    m17: 'r1',
    m20: 'r1',
    m05: 'r2',
    m24: 'r2',
    m01: 'r3',
    m02: 'r3',
    m04: 'r3',
    m07: 'r3',
    m29: 'r4',
    m31: 'r4',
  },
}

/** Začetni prevozi (dogodek → član → prijava). */
export const zacetniPrevoz: Record<string, Record<string, TransportEntry>> = {
  e24: pacugPrevozMap,
  e23: {
    m04: { nacin: 'vozim', mesta: 3, kraj: 'Krško', ura: '05:45', opomba: 'Prostor za dva kovčka.' },
    m05: { nacin: 'vozim', mesta: 2, kraj: 'Brežice', ura: '06:00' },
    m03: { nacin: 'potrebujem', voznikId: 'm04' },
    m11: { nacin: 'potrebujem', voznikId: 'm04' },
    m12: { nacin: 'potrebujem' },
    m16: { nacin: 'potrebujem' },
    m01: { nacin: 'sam' },
    m02: { nacin: 'sam' },
  },
}

export const events: ChoirEvent[] = [...osnovniDogodki, ...dodatniDogodki, pacug].sort((a, b) =>
  a.datum.localeCompare(b.datum),
)

/** Odsotni člani na preteklih dogodkih (za zgodovino prisotnosti). */
export const pretekleOdsotnosti: Record<string, string[]> = {
  e01: ['m06', 'm14', 'm23', 'm33'],
  e03: ['m04', 'm06', 'm18', 'm30', 'm41'],
  e04: ['m14', 'm18'],
  e05: ['m06', 'm27', 'm33', 'm39'],
  e06: ['m04', 'm06', 'm14', 'm23', 'm30', 'm37', 'm41'],
  e07: ['m03', 'm06', 'm23', 'm33'],
  e08: ['m06', 'm18', 'm27'],
  e09: ['m04', 'm06', 'm14', 'm30', 'm39'],
  e10: ['m06', 'm23', 'm33', 'm41'],
}
